var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "30e7976ea1351b3318d78799537880f1b91965bc"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["marketing-site@roadie"] = {
  id: "30e7976ea1351b3318d78799537880f1b91965bc"
};